<template>
  <section class="logos-banner">
    <!-- Infinite scroll for all screens -->
    <div class="mobile-logos">
      <v-container class="marquee-wrapper">
        <div class="marquee-track">
          <div class="marquee-content">
            <img
              v-for="i in 7"
              :key="'a' + i"
              :src="require(`@/assets/images/2.LogosBanner/${i}.webp`)"
              :alt="`Partner logo ${i}`"
              class="logo-img"
            />
            <img
              v-for="i in 7"
              :key="'b' + i"
              :src="require(`@/assets/images/2.LogosBanner/${i}.webp`)"
              :alt="`Partner logo ${i}`"
              class="logo-img"
            />
          </div>
        </div>
      </v-container>
    </div>
  </section>
</template>

<script>
import { animateOnScroll } from '@/mixins/animateOnScroll'

export default {
  name: 'LogosBanner',
  mixins: [animateOnScroll]
}
</script>

<style scoped>
.logos-banner {
  background: #ededed;
  padding: 20px 0;
}

.logo-img {
  height: 66px;
  width: auto;
  object-fit: contain;
  display: block;
}

.mobile-logos {
  display: block;
  width: 100%;
}

.marquee-wrapper {
  max-width: 1400px;
  margin: 0 auto;
  overflow: hidden;
  -webkit-mask-image: linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%);
  mask-image: linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%);
}

.marquee-track {
  width: 100%;
}

.marquee-content {
  display: flex;
  align-items: center;
  gap: 40px;
  width: max-content;
  animation: marquee 15s linear infinite;
  will-change: transform;
  backface-visibility: hidden;
}

@media (max-width: 600px) {
  .marquee-content .logo-img {
    height: 44px;
  }

  .marquee-content {
    gap: 30px;
  }
}

@keyframes marquee {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(-50%, 0, 0);
  }
}
</style>
